import { Flex } from '@chakra-ui/react';
import { Pagination } from '@morressier/alembic';
import { memo } from 'react';

interface Props {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default memo(function PaginationSection({
  page,
  totalPages,
  onPageChange
}: Props) {
  if (totalPages <= 1) return null;

  return (
    <Flex justifyContent="center">
      <Pagination
        ariaLabel="Pagination"
        currentPage={page}
        totalPages={totalPages}
        onPageChange={onPageChange}
      />
    </Flex>
  );
});
